type ErrorType = {
    [key: string]: string
}

export const ErrorCodes: ErrorType = {
    'auth_invalid_credentials': 'Неверный логин или пароль',
    'auth_not_found': 'Ползователя с указанным логином не существует',
    'profile_template_already_exists': 'Профиль пользователя для указанной роли уже существует',
    'profile_default_fields_delete_attempt': 'Стандартные поля нельзя удалить',
    'group_not_found': 'Группы не существует',
    'auth_admin_token_error': 'Время предыдущей сессии истекло, пройдите авторизацию повторно',
    'auth_admin_unauthorized_error': 'Ошибка авторизации',
    'admin_invalid_jwt': 'Ошибка авторизации',
    'not_enought_balance': 'Недостаточно средств для списания',
    'profile_template_not_found': 'Профилья с указанным ID не существует',
    'profile_field_forbidden_action': 'Вы не можете взаимодействовать с чужим профилем',
    'role_system_delete_attempt': 'Стандартную роль нельзя удалить',
    'role_system_update_attempt': 'Стандартную роль нельзя изменить',
    'group_system_delete_attempt': 'Стандартную группу нельзя удалить',
    'self_foundation_accrual': 'Невозможно пожертвование в фонд сообщества',
    'integration_not_found': 'Интеграция не найдена',
    'amount not enough': 'Недостаточно средств для списания',
    'bonus_mapping_not_found': 'Выбранный бонус невозможно вывести',
    'community_logo_required': 'Для вывода бонусов нужен логотип организации',
    'main_bonus_not_found': 'Выбранный бонус не найден',
    'subbonus_icon_generate_failed': 'Не удалось подготовить иконку бонуса для социального кошелька',
    'subbonus_create_failed': 'Не удалось создать бонус для социального кошелька',
    'bonus_mapping_create_failed': 'Не удалось подготовить связь бонусов для вывода',
    'no_users_to_broadcast': 'В выбранных группах нет пользователей',
    'community_already_exists': 'Организация с таким ИНН уже зарегистрирована',
    'legal_entity_already_exists': 'Похоже, компания с такими данными уже зарегистрирована в системе.\n\nДоступ к личному кабинету был направлен через ЭДО.\n\nЕсли вы не получили письмо с доступом или хотите восстановить его, свяжитесь с нашей службой поддержки:\n\n📧 [support@oe-media.ru]',
    'bad_request': 'Некорректный запрос',
    'email_confirmation_not_found': 'Код подтверждения email не недействителен. Пожалуйста, запросите новый код',
    'email_confirmation_mismatch': 'Неверный код подтверждения email',
    'email_confirmation_invalid': 'Код подтверждения email недействителен. Пожалуйста, запросите новый код',
    'email_not_confirmed': 'Email не подтвержден. Пожалуйста, подтвердите email',
    'phone_confirmation_invalid': 'Код подтверждения телефона недействителен. Пожалуйста, запросите новый код',
    'phone_confirmation_mismatch': 'Неверный код подтверждения телефона',
    'phone_not_confirmed': 'Телефон не подтвержден. Пожалуйста, подтвердите телефон',
    'aviabooking_refund_in_progress': 'По этой брони уже выполняется возврат — повторная отмена невозможна',
    'aviabooking_void_window_expired': 'Аннулировать билет можно только в день его выписки по МСК — срок истёк',
    'aviabooking_booking_status_conflict': 'Статус брони изменился. Обновите страницу и попробуйте снова',
    'aviabooking_booking_status_not_cancellable': 'Текущий статус брони не допускает отмену',
    'aviabooking_partner_action_not_allowed': 'Партнёр не разрешает отмену этой брони',
    'aviabooking_booking_under_manual_review': 'Бронь передана на ручной разбор — отмена из админки недоступна. Заявка передана в поддержку',
    'aviabooking_cancel_availability_unknown': 'Сервер не сообщил доступность отмены. Повторите попытку позже',
    'aviabooking_cancel_failed': 'Не удалось отменить бронь. Повторите попытку позже или обратитесь в поддержку',
    // Партнёрское API и журналы: контракт провайдера CommunityServiceExternalApi@1.0.0
    // (oem-backend-community-nest, Wave W3). Значения error_id менять нельзя.
    'partner_cursor_invalid': 'Страница списка устарела. Вернитесь на первую страницу и повторите',
    'export_format_invalid': 'Неподдерживаемый формат экспорта',
    'export_limit_exceeded': 'Слишком большой объём выгрузки. Сузьте период или фильтры и повторите',
    'forbidden': 'Недостаточно прав для этой операции',
    'api_key_disabled': 'API-ключ отключён',
    'unauthorized': 'Ошибка авторизации',
    'partner_scope_forbidden': 'У ключа нет разрешения на это чтение',
    'partner_resource_not_found': 'Запись не найдена',
    'rate_limit_exceeded': 'Слишком много запросов. Повторите попытку позже',
    'partner_audit_unavailable': 'Журнал партнёрского API временно недоступен. Повторите попытку позже',
}

export const getErrorMessage = (error: string | undefined | ErrorType) => {
    let error_id = error as string
    if (typeof error === 'object') {
        error_id = error.error_id
    }
    if (!error_id || !ErrorCodes[error_id]) {
        return 'Произошла непредвиденная ошибка'
    }
    return ErrorCodes[error_id]
}
